module.exports = __webpack_public_path__ + "static/media/aiva_appearance.4d648caf.jpg";